import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Breadcrumbs from '../components/Breadcrumbs';
import { useAnimationObserver } from '../hooks/useAnimationObserver';
const PageLayout = () => {
  const location = useLocation();
  const {
    setupAnimations
  } = useAnimationObserver();
  // Reset scroll position when navigating to a new page
  useEffect(() => {
    window.scrollTo(0, 0);
    // Setup animations on each page load
    const cleanup = setupAnimations();
    return cleanup;
  }, [location.pathname, setupAnimations]);
  return <div className="w-full min-h-screen bg-cream-200 text-navy-800 premium-pattern" data-id="element-395">
      <Header data-id="element-396" />
      {location.pathname !== '/' && <Breadcrumbs data-id="element-397" />}
      <main data-id="element-398">
        <Outlet data-id="element-399" />
      </main>
      <Footer data-id="element-400" />
    </div>;
};
export default PageLayout;